// src/features/bookings/components/BookingList/BookingStats.jsx
import React from 'react';
import styles from './BookingStats.module.css';
import { BOOKING_TYPE_LABELS, formatNumber } from '../../../../shared/utils/formatters';

const TYPE_COLORS = {
  graduation:        'teal',
  wedding:           'pink',
  kids:              'amber',
  event:             'purple',
  special:           'blue',
  digital_marketing: 'green',
};

const BookingStats = ({ statistics }) => {
  if (!statistics || Object.keys(statistics).length === 0) return null;

  const entries = Object.entries(statistics);

  const totals = entries.reduce(
    (acc, [, data]) => ({
      count:       acc.count + (data.count || 0),
      total_value: acc.total_value + parseFloat(data.total_value || 0),
    }),
    { count: 0, total_value: 0 }
  );

  return (
    <div className={styles.strip}>
      {/* بطاقة الإجمالي */}
      <div className={`${styles.cell} ${styles.cellTotal}`}>
        <span className={styles.cellNum}>{totals.count}</span>
        <span className={styles.cellLabel}>إجمالي الحجوزات</span>
        <span className={styles.cellVal}>
          {formatNumber(totals.total_value, 0)} <small>د.ع</small>
        </span>
      </div>

      {/* فاصل */}
      <div className={styles.divider} />

      {/* بطاقة لكل نوع */}
      {entries.map(([type, data]) => (
        <div
          key={type}
          className={`${styles.cell} ${styles[`cell_${TYPE_COLORS[type] || 'default'}`]}`}
        >
          <span className={styles.cellNum}>{data.count}</span>
          <span className={styles.cellLabel}>
            {BOOKING_TYPE_LABELS[type] ?? type}
          </span>
          <span className={styles.cellVal}>
            {formatNumber(data.total_value, 0)} <small>د.ع</small>
          </span>
          {type === 'graduation' && data.total_students > 0 && (
            <span className={styles.cellSub}>
              {formatNumber(data.total_students, 0)} طالب
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default BookingStats;